import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class FleteService {

  constructor(private config: ConfigService,
    private http: HttpClient) { }

  /**Obtener el rango para configuración de las variables */
  getRangoProveedor(token: String) {
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Flete/Rangos";
    return this.http.get(url, requestOptions);
  }

  /**Fijar rangos */
  setRangoProveedor(token: String, data: any) {
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Flete/Rangos";
    return this.http.post(url, data, requestOptions);
  }

  // get flete de la cotización
  getFlete = (idCotizacion: number, idCiudad: number, isInit:number) => {
    const requestOptions = new Object({
      responseType: 'text'
    });
    const url = this.config.urlService + "api/Flete/" + idCotizacion + "/" + idCiudad + "/" + isInit;
    return this.http.get(url, requestOptions);
  }

  getFleteCiudad(token: String, idCiudad: number) {
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Flete/Configuration/" + idCiudad;
    return this.http.get(url, requestOptions);
  }

  /**Fijar rangos */
  setFleteCiudad(token: String, data: any) {
    const requestOptions: object = {
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    }
    const url = this.config.urlService + "api/Flete/setFlete";
    return this.http.post(url, data, requestOptions);
  }

}
